import { Skeleton } from '@/shared/components/ui/skeleton';
import { SkeletonCard, SkeletonPagination, SkeletonSearchBar } from './primitives';

/**
 * Content-only skeleton for admin pages.
 * Use this when the header is already rendered and only the data table area is loading.
 * Matches DataTable component structure with search bar, action button, rows, and pagination.
 */
export function AdminContentSkeleton() {
  return (
    <div className="space-y-6" aria-busy="true" aria-label="Loading admin content">
      {/* Search and Action Bar - matches DataTable structure */}
      <SkeletonCard>
        <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
          <SkeletonSearchBar />
          {/* Action button */}
          <Skeleton className="h-10 w-full sm:w-32 rounded-md" />
        </div>
      </SkeletonCard>

      {/* Data Table Skeleton */}
      <div className="bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700/50 overflow-hidden shadow-sm">
        {/* Table Header */}
        <div className="border-b border-gray-200 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-700/30 px-6 py-4">
          <div className="flex items-center gap-6">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-4 w-20 hidden sm:block" />
            <Skeleton className="h-4 w-24 hidden md:block" />
            <Skeleton className="h-4 w-16 ml-auto" />
          </div>
        </div>

        {/* Table Rows */}
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className="border-b border-gray-100 dark:border-slate-700/50 px-6 py-4 last:border-b-0"
          >
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <Skeleton className="h-10 w-10 rounded-full flex-shrink-0" />
                <div className="space-y-1.5 min-w-0">
                  <Skeleton className="h-4 w-36" />
                  <Skeleton className="h-3 w-24" />
                </div>
              </div>
              <Skeleton className="h-6 w-16 rounded-full hidden sm:block" />
              <Skeleton className="h-4 w-20 hidden md:block" />
              <div className="flex gap-1 flex-shrink-0">
                <Skeleton className="h-8 w-8 rounded" />
                <Skeleton className="h-8 w-8 rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <SkeletonPagination className="pt-2" />
    </div>
  );
}
